import request from '@/utils/request'

// 根据商品编码模糊查询
export function skuList(data) {
	return request({ url: '/product/page/sku/list', method: 'post', data })
}
// 上传文件
export function fileUpload(data) {
	return request({ url: '/file/upload', method: 'post', data })
}
// 新增分类
export function addType(data) {
	return request({ url: '/pageConfig/addType', method: 'post', data })
}
// 编辑分类
export function updateType(data) {
	return request({ url: '/pageConfig/updateType', method: 'post', data })
}
// 查询分类
export function findNameByType(data) {
	return request({ url: '/pageConfig/findNameByType', method: 'post', data })
}
// 排序移动
export function pageConfigMove(data) {
	return request({ url: '/pageConfig/move', method: 'post', data })
}

// =================广告图配置=====================//
// 广告图专属分类
export function findNameByTypeForAdv(data) {
	return request({ url: '/pageConfig/findNameByTypeForAdv', method: 'post', data })
}
export function findNameByTypeForAdvNotShopMall(data) {
	return request({ url: '/pageConfig/findNameByTypeForAdvNotShopMall', method: 'post', data })
}
// 广告图列表
export function advertisementList(data) {
	return request({ url: '/pageConfig/advertisementList', method: 'post', data })
}
export function queryFloorAdvListForShopMall(data) {
	return request({ url: '/pageConfig/queryFloorAdvListForShopMall', method: 'post', data })
}
export function advertisementListForShopMall(data) {
	return request({ url: '/pageConfig/advertisementListForShopMall', method: 'post', data })
}
export function advertisementListForOther(data) {
	return request({ url: '/pageConfig/advertisementListForOther', method: 'post', data })
}
export function queryFloorAdvListForOther(data) {
	return request({ url: '/pageConfig/queryFloorAdvListForOther', method: 'post', data })
}
// 弹窗广告图列表
export function queryFloorUpAdvListForOther(data) {
	return request({ url: '/pageConfig/queryFloorAdvListForPopup', method: 'post', data })
}
// 新增广告
export function createAdvertisement(data) {
	return request({ url: '/pageConfig/createAdvertisement', method: 'post', data })
}
// 编辑广告
export function updateAdvertisement(data) {
	return request({ url: '/pageConfig/updateAdvertisement', method: 'post', data })
}
// 删除广告
export function deleteAdvertisement(data) {
	return request({ url: '/pageConfig/deleteAdvertisement', method: 'post', data })
}
// 广告禁用
export function forbiddenAdv(data) {
	return request({ url: '/pageConfig/forbiddenAdv', method: 'post', data })
}
// 广告启用
export function useAdv(data) {
	return request({ url: '/pageConfig/useAdv', method: 'post', data })
}
// =================首页商品推荐============================
// 商品推荐
export function findPageProductReconmdList(data) {
	return request({ url: '/pageConfig/findPageProductReconmdList', method: 'post', data })
}
// 商品新增
export function addPageProductReconmd(data) {
	return request({ url: '/pageConfig/addPageProductReconmd', method: 'post', data })
}
// 商品编辑
export function modifyPageProductReconmd(data) {
	return request({ url: '/pageConfig/modifyPageProductReconmd', method: 'post', data })
}
// 商品详情
export function findPageProductReconmd(data) {
	return request({ url: '/pageConfig/findPageProductReconmd', method: 'post', data })
}
// 商品删除
export function dropPageProductReconmd(data) {
	return request({ url: '/pageConfig/dropPageProductReconmd', method: 'post', data })
}
// 商品详情里的删除
export function deleteProductReconmd(data) {
	return request({ url: '/pageConfig/deleteProductReconmd', method: 'post', data })
}
// 商品排序
export function productReconmdMove(data) {
	return request({ url: '/pageConfig/productReconmd/move', method: 'post', data })
}

// =================首页楼层设置============================
// 位置修改
export function updateSort(data) {
	return request({ url: '/pageConfig/updateSort', method: 'post', data })
}
// 楼层模块删除/上架/下架/待上架
export function updateFloorStatus(data) {
	return request({ url: '/pageConfig/updateFloorStatus', method: 'post', data })
}
// 查询展示类型
export function queryLayout(data) {
	return request({ url: '/pageConfig/queryLayout', method: 'post', data })
}
// 查出虚拟分类
export function productVirtualList(data) {
	return request({ url: '/product/virtual/list', method: 'post', data })
}
// 查询商铺列表
export function queryAllShopList(data) {
	return request({ url: '/shop/queryAllShopList', method: 'post', data })
}

// 头部广告分页查询
export function queryFloorAdvList(data) {
	return request({ url: '/pageConfig/queryFloorAdvList', method: 'post', data })
}
// 新增楼层轮播广告
export function addFloorAdv(data) {
	return request({ url: '/pageConfig/addFloorAdv', method: 'post', data })
}

// 头部推荐分页查询
export function queryFloorMenuList(data) {
	return request({ url: '/pageConfig/queryFloorMenuList', method: 'post', data })
}
// 新增楼层分类推荐
export function addFloorClassify(data) {
	return request({ url: '/pageConfig/addFloorClassify', method: 'post', data })
}
// 楼层分类详情
export function queryFloorMenu(data) {
	return request({ url: '/pageConfig/queryFloorMenu', method: 'post', data })
}
// 编辑楼层分类推荐
export function updateFloorMenu(data) {
	return request({ url: '/pageConfig/updateFloorMenu', method: 'post', data })
}

// 推荐店铺分页查询
export function queryFloorShopList(data) {
	return request({ url: '/pageConfig/queryFloorShopList', method: 'post', data })
}
// 新增店铺推荐
export function addFloorShop(data) {
	return request({ url: '/pageConfig/addFloorShop', method: 'post', data })
}

// 楼层管理分页查询
export function queryFloorSetupList(data) {
	return request({ url: '/pageConfig/queryFloorSetupList', method: 'post', data })
}

// 横向楼层管理分页查询
export function queryFloorSetupHoriList(data) {
	return request({ url: '/pageConfig/queryFloorSetupHoriList', method: 'post', data })
}

// 新增楼层
export function addFloor(data) {
	return request({ url: '/pageConfig/addFloor', method: 'post', data })
}

// 新增多个楼层
export function addMoreFloor(data) {
	return request({ url: '/pageConfig/addMoreFloor', method: 'post', data })
}

// 楼层详情
export function floorDetail(data) {
	return request({ url: '/pageConfig/floorDetail', method: 'post', data })
}

// 楼层详情(关联多层)
export function floorMoreDetail(data) {
	return request({ url: '/pageConfig/floorMoreDetail', method: 'post', data })
}

// 编辑楼层
export function updateFloor(data) {
	return request({ url: '/pageConfig/updateFloor', method: 'post', data })
}

// 编辑楼层(关联多个楼层)
export function updateMoreFloor(data) {
	return request({ url: '/pageConfig/updateMoreFloor', method: 'post', data })
}

// =================资讯列表================================
// 资讯列表
export function queryNewsList(data) {
	return request({ url: '/pageConfig/queryNewsList', method: 'post', data })
}
// 新增资讯
export function addNews(data) {
	return request({ url: '/pageConfig/addNews', method: 'post', data })
}
// 修改资讯
export function updateNews(data) {
	return request({ url: '/pageConfig/updateNews', method: 'post', data })
}
// 作废资讯
export function dropNews(data) {
	return request({ url: '/pageConfig/dropNews', method: 'post', data })
}
// 发布资讯
export function releaseNews(data) {
	return request({ url: '/pageConfig/releaseNews', method: 'post', data })
}





// 资讯评论
export function queryPageCommentList(data) {
	return request({ url: '/pageConfig/queryPageCommentList', method: 'post', data })
}

// 删除资讯评论
export function deleteNewsComment(data) {
	return request({ url: '/pageConfig/deleteNewsComment', method: 'post', data })
}

//  资讯评论按钮修改

export function updateBusinessCircleNews(data) {
	return request({ url: '/pageConfig/updateBusinessCircleNews', method: 'post', data })
}

//   资讯详情
export function detailForNews(data) {
	return request({ url: '/pageConfig/detailForNews', method: 'post', data })
}

//   ======================资讯分类相关修改===================================

// 资讯分类
export function queryNewsTabType(data) {
	return request({ url: '/page/conf/list', method: 'post', data })
}

//   资讯分类新增
export function addNewsType(data) {
	return request({ url: '/pageConfig/addType ', method: 'post', data })
}
//   资讯分类编辑
export function updateNewsType(data) {
	return request({ url: '/pageConfig/updateType ', method: 'post', data })
}
//   资讯分类删除
export function deleteNewsType(data) {
	return request({ url: '/pageConfig/deleteType', method: 'post', data })
}


// 资讯分类列表
export function newsTypeList(data) {
	return request({ url: '/page/query/list', method: 'post', data })
}


// 资讯列表

export function newsListAll(data) {
	return request({ url: '/page/news/list', method: 'post', data })
}
// ======================新增集采页相关修改===================================
// 商城内的集采楼层
export function addFloorForFresh(data) {
	return request({ url: '/pageConfig/addFloorForFresh', method: 'post', data })
}
// 新增集采楼层
export function queryFloorSetupListForFresh(data) {
	return request({ url: '/pageConfig/queryFloorSetupListForFresh', method: 'post', data })
}

/**
 * V110店铺查看更多相关修改的接口
 */
// 推荐店铺-移动
export function floorShopMove(data) {
	return request({ url: 'pageConfig/floor/shop/move', method: 'post', data })
}
// 店铺-查看更多-列表
export function queryFloorShopListMore(data) {
	return request({ url: 'pageConfig/queryFloorShopList/more', method: 'post', data })
}
// 店铺-查看更多-添加
export function addFloorShopMore(data) {
	return request({ url: 'pageConfig/addFloorShop/more', method: 'post', data })
}
// 店铺-查看更多-移动
export function floorShopMoreMove(data) {
	return request({ url: 'pageConfig/floor/shop/more/move', method: 'post', data })
}

// ===========v118
export function updateFloorSetup(data) {
  return request({ url: 'pageConfig/updateFloorSetup', method: 'post', data })
}

//小程序分类页配置  大类列表
export function getCategoryList(data) {
  return request({ url: '/product/virtual/bigCategory/list', method: 'post', data })
}
//小程序分类页配置  列表排序
export function sortCategoryList(data) {
  return request({ url: '/product/virtual/bigCategory/move', method: 'post', data })
}
//小程序分类页配置  上架
export function enabledCategory(data) {
  return request({ url: '/product/virtual/category/enabled', method: 'post', data })
}
//小程序分类页配置  下架
export function disableCategory(data) {
  return request({ url: '/product/virtual/category/disable', method: 'post', data })
}
//小程序分类页配置  删除
export function deleteCategory(data) {
  return request({ url: '/product/virtual/bigCategory/delete', method: 'post', data })
}
//小程序分类页配置 新增大类
export function addCategory(data) {
  return request({ url: '/product/virtual/bigCategory/create', method: 'post', data })
}
//小程序分类页配置 编辑大类
export function editCategory(data) {
  return request({ url: '/product/virtual/bigCategory/modify', method: 'post', data })
}
//小程序分类页配置 获取详情
export function getCategoryDetail(data) {
  return request({ url: '/product/virtual/bigCategory/detail', method: 'post', data })
}

//小程序首页菜单类型预置数据查询
export function getTypeList(data) {
	return request({ url: '/homePage/typeList', method: 'post', data })
}
//小程序首页菜单入口数据列表
export function homePageDistrictConfigList(data) {
	return request({ url: '/homePage/homePageDistrictConfigList', method: 'post', data })
}
//小程序首页菜单入口 新增
export function addHomePageDistrictConfig(data) {
	return request({ url: '/homePage/addHomePageDistrictConfig', method: 'post', data })
}
//小程序首页菜单入口 编辑
export function updateHomePageDistrictConfig(data) {
	return request({ url: '/homePage/updateHomePageDistrictConfig', method: 'post', data })
}
//小程序首页菜单入口 排序
export function moveHomePageDistrictConfig(data) {
	return request({ url: '/homePage/moveHomePageDistrictConfig', method: 'post', data })
}
//小程序启动页类型预置数据查询
export function getStartPageTypeList(data) {
	return request({ url: '/homePage/startPageTypeList', method: 'post', data })
}
//小程序启动页数据查询
export function startPageConfigList(data) {
	return request({ url: '/homePage/startPageConfigList', method: 'post', data })
}
//小程序启动页 新增
export function addStartPageConfig(data) {
	return request({ url: '/homePage/addStartPageConfig', method: 'post', data })
}
//小程序启动页 编辑
export function updateStartPageConfig(data) {
	return request({ url: '/homePage/updateStartPageConfig', method: 'post', data })
}
//小程序启动页 启用
export function enableStartPageConfig(data) {
	return request({ url: '/homePage/enableStartPageConfig', method: 'post', data })
}
// =================购前指南配置=====================//
// 商户分类楼层
export function getShopCategoryList(data) {
	return request({ url: '/page/floor/shop/queryPageList', method: 'post', data })
}
// 分类楼层商户列表
export function getShopDetailInPage(data) {
	return request({ url: '/page/floor/shop/queryDetailInPage', method: 'post', data })
}
// 添加或修改购物指南内页分类
export function addOrUpdateFloor(data) {
	return request({ url: '/page/floor/shop/addOrUpdateFloor', method: 'post', data })
}
// 删除购物指南内页分类
export function doFloorDelete(data) {
	return request({ url: '/page/floor/shop/doFloorDelete', method: 'post', data })
}
// 购物指南内页分类排序移动
export function moveFloor(data) {
	return request({ url: '/page/floor/shop/moveFloor', method: 'post', data })
}
// 购物指南内页分类下的商户绑定
export function addShopSet(data) {
	return request({ url: '/page/floor/shop/addShopSet', method: 'post', data })
}
// 删除楼层下面的商户
export function doShopSetDelete(data) {
	return request({ url: '/page/floor/shop/doShopSetDelete', method: 'post', data })
}
// 购物指南内页分类下的商户排序移动
export function moveShop(data) {
	return request({ url: '/page/floor/shop/moveShop', method: 'post', data })
}



// WEBPACK FOOTER //
// ./src/api/page.js